import DocumentsExpiredAlert from './DocumentsExpiredAlert';

export default DocumentsExpiredAlert;
